import Vue from "vue";
import { DEFAULT_COLOR_PICKER_OPTIONS } from "../constants/default-values";

Vue.mixin({
  methods: {
    getColorPickerOptions() {
      const listUserDefinedColors = [this.$store.getters.primaryColor,
      this.$store.getters.primaryDarkerColor,
      this.$store.getters.secondaryColor,
      this.$store.getters.secondaryDarkerColor,
      this.$store.getters.profileTextColor,
      this.$store.getters.cancelButtonColor,
      this.$store.getters.cancelButtonHoverColor,
      ];
      if (this.$store.getters.agencyPublic && this.$store.getters.agencyPublic.public_advance_setting) {
        if (this.$store.getters.agencyPublic.public_advance_setting.cancel_button_color) {
          listUserDefinedColors.push(this.$store.getters.agencyPublic.public_advance_setting.cancel_button_color);
        }
        if (this.$store.getters.agencyPublic.public_advance_setting.cancel_button_hover_color) {
          listUserDefinedColors.push(this.$store.getters.agencyPublic.public_advance_setting.cancel_button_hover_color);
        }
        if (this.$store.getters.agencyPublic.public_advance_setting.label_color) {
          listUserDefinedColors.push(this.$store.getters.agencyPublic.public_advance_setting.label_color);
        }
      }
      let result = [...listUserDefinedColors.filter(color => color), ...DEFAULT_COLOR_PICKER_OPTIONS];
      // Remove duplicate items
      result = [...new Set(result)];
      // Get first 16 items
      return result.slice(0, 16).map(color => ({ color: color, showBorder: true }));
    }
  }
});



// WEBPACK FOOTER //
// ./src/mixins/color-handling.js